export enum BlueprintActions {
  CreateBlueprint,
  CreateStack,
  Edit,
  Publish,
}
